// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__HsspD","welcomeHeader":"styles_welcomeHeader__Aun3/","divider":"styles_divider__7qrEk"};